import axios from 'axios';
import { clearSessionKeepingAdHint } from './session';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api/user';
const API_TIMEOUT = parseInt(process.env.REACT_APP_API_TIMEOUT) || 10000;

const http = axios.create({
  baseURL: API_BASE_URL,
  timeout: API_TIMEOUT,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

http.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if ([502, 401].includes(error.response?.status)) {
      clearSessionKeepingAdHint();
      window.location.href = '/';
    } else {
      return Promise.resolve(error.response?.data);
    }
  }
);

export default http;
